export const RANGE = {
  CONTRACTOR_TIME: 'ContrTime',
  LAST_365_DAYS: 'Last365Days',
  LAST_30_DAYS: 'Last30Days',
  LAST_7_DAYS: 'Last7Days',
  LAST_MONTH: 'LastMonth',
  THIS_MONTH: 'ThisMonth',
  LAST_2_MONTHS: 'Last2Months',
  LAST_3_MONTHS: 'Last3Months',
  LAST_6_MONTHS: 'Last6Months',
  LAST_3_MONTH: 'Last3Month',
  LAST_WEEK: 'LastWeek',
  LAST_YEAR: 'LastYear',
  THIS_YEAR: 'ThisYear',
  ALL_TIME: 'AllTime',
  YESTERDAY: 'Yesterday',
  TODAY: 'Today',
  CUSTOM: 'Custom',
};

export const CUSTOMER_MAX_ALLOWED_MAX_TEAM_USERS = 20;

export const CUSTOMER_TYPE_CONTRACTOR_ID = 101;
export const CUSTOMER_TYPE_MEDICAL_ID = 102;
export const CUSTOMER_TYPE_GENERAL_ID = 103;
export const PARTNER_TYPE_PARTNER_ID = 111;

export const PARTNER_STATUS_PENDING_ID = 201;
export const PARTNER_STATUS_ACTIVE_ID = 202;
export const PARTNER_STATUS_CANCELED_ID = 203;

export const SOCIAL_MEDIA_FACEBOOK_ID = 301;
export const SOCIAL_MEDIA_INSTAGRAM_ID = 302;
export const SOCIAL_MEDIA_LINKEDIN_ID = 303;

export const SOCIAL_MEDIA_CONTENT_TYPE_COVER_ID = 311;
export const SOCIAL_MEDIA_CONTENT_TYPE_POST_ID = 312;
export const SOCIAL_MEDIA_CONTENT_TYPE_STORY_ID = 313;


export const SOCIAL_MEDIA_CONTENT_TYPES_MAP = {
  [SOCIAL_MEDIA_FACEBOOK_ID]: [
    SOCIAL_MEDIA_CONTENT_TYPE_COVER_ID,
    SOCIAL_MEDIA_CONTENT_TYPE_POST_ID,
    SOCIAL_MEDIA_CONTENT_TYPE_STORY_ID,
  ],
  [SOCIAL_MEDIA_INSTAGRAM_ID]: [
    SOCIAL_MEDIA_CONTENT_TYPE_POST_ID,
    SOCIAL_MEDIA_CONTENT_TYPE_STORY_ID,
  ],
  [SOCIAL_MEDIA_LINKEDIN_ID]: [
    SOCIAL_MEDIA_CONTENT_TYPE_COVER_ID,
    SOCIAL_MEDIA_CONTENT_TYPE_POST_ID,
  ],
};
